import React from "react";
import { PDFObject } from "react-pdfobject";

export default function Preview({ fileName, binaryData, mimeType }) {
  const fileBlob = new File([binaryData], fileName, { type: mimeType });
  return (
    <PDFObject
      url={URL.createObjectURL(fileBlob)}
      containerProps={{
        style: {
          height: "100%",
          width: "100%",
        },
      }}
      pdfOpenParams={{
        view: "FitBV",
        toolbar: 1,
      }}
    />
  );
}
